// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__AfrrH","toolTipText":"style_toolTipText__Zyko4"};